import { render, staticRenderFns } from "./ServiceListSettingsWidget.vue?vue&type=template&id=81db5288"
import script from "./ServiceListSettingsWidget.vue?vue&type=script&lang=js"
export * from "./ServiceListSettingsWidget.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports